import Moment from 'moment';

// mui
import { Typography as TypographyBase } from '@mui/material';
import { getShortDateTimeFromUtc } from '../../../../../utils/csvUtils';
import { getCowbellTranslations } from '../../../../../i18n/translations';

export const tabs = {
  POLICY_INFORMATION_TAB: 'policy-information',
  ORGANIZATION_DETAILS_TAB: 'organization-details',
  COWBELL_FACTORS_TAB: 'cowbell-factors',
};

const { t } = getCowbellTranslations();

export const subroutes = [
  {
    label: 'Policy Information',
    value: tabs.POLICY_INFORMATION_TAB,
  },
  {
    label: `${t('organization')} Details`,
    value: tabs.ORGANIZATION_DETAILS_TAB,
  },
  {
    label: 'Cowbell Factors',
    value: tabs.COWBELL_FACTORS_TAB,
  },
];

export const formatCancellationPolicy = (
  cancellationDate: any,
  cancellationTriggerDate: any
) => {
  const uiCancellationDate = cancellationTriggerDate
    ? getShortDateTimeFromUtc(cancellationTriggerDate)
    : '-';

  const uiCancellationEffectiveDate = cancellationDate
    ? getShortDateTimeFromUtc(cancellationDate)
    : '-';

  return { uiCancellationDate, uiCancellationEffectiveDate };
};

/**
 * Dates only. Monetary amounts are rendered by CurrencyAmount at the call site, using the
 * currency the API supplies with the policy, rather than one inferred from the product here.
 */
export const formatPolicySummaryData = ({
  effectiveDate,
  expiresOn,
  issuedDate,
}: any) => {
  const uiEffectiveDate = Moment.utc(effectiveDate).format(
    'MMM DD, YYYY h:mm a'
  );

  const uiExpiresOn = Moment.utc(expiresOn).format('MMM DD, YYYY h:mm a');
  const uiIssuedDate = issuedDate
    ? Moment.utc(issuedDate).format('MMM DD, YYYY h:mm a')
    : '-';

  return {
    uiEffectiveDate,
    uiExpiresOn,
    uiIssuedDate,
  };
};

export const PolicyDrawerTypography = ({ children, ...props }: any) => (
  <TypographyBase variant="caption" {...props}>
    {children}
  </TypographyBase>
);
